// @ts-nocheck
import { createStore } from "vuex";
import accounts from "@modules/accounts/store";
import auth from "@modules/auth/store";
import cards from "@modules/cards/store";
import payments from "@modules/payments/store/payments";
import transactions from "@modules/payments/store/transactions";
import refs from "@modules/shared/store/refs";
import userManagement from "@modules/users/store";

export default createStore({
  state: {
    customXTraceId: null
  },
  mutations: {
    SET_X_TRACE_ID(state, payload) {
      state.customXTraceId = payload
    },
    CLEAR_X_TRACE_ID(state) {
      state.customXTraceId = null
    }
  },
  getters: {
    xTraceId: (state) => state.customXTraceId
  },
  modules: {
    auth,
    accounts,
    payments,
    transactions,
    cards,
    refs,
    userManagement
  },
});
